import { createRouter, createWebHistory } from 'vue-router'
import Guard from '../services/middleware'

import Home from '@/components/Home'
import Login from '@/components/Home/Login'
import ForgotPassword from '@/components/Home/ForgotPassword'
import PasswordReset from '@/components/Home/PasswordReset'

import PrintInterpretation from '@/components/Home/Print/PrintInterpretation'
import PrintTranslation from '@/components/Home/Print/PrintTranslation'
import PrintTelephonic from '@/components/Home/Print/PrintTelephonic'
import PrintDigitalSignature from '@/components/Home/Print/PrintDigitalSignature'

import CaptureAvailability from '@/components/Home/CaptureAvailability'
import CaptureReminders from '@/components/Home/CaptureReminders'
import CapturePoConfirm from '@/components/Home/CapturePoConfirm'
import CaptureDigitalVOS from '@/components/Capture/CaptureDigitalVOS'
import SignUp from '@/components/Home/SignUp'

import FAQ from '@/components/FAQ/Main'

import Requests from '@/components/Home/Jobs/Index';

import CaptureSignature from '@/components/Home/Compliances/Signature/FromEmail';
import Compliances from '@/components/Home/Compliances/Index';
import Items from '@/components/Home/Compliances/Items/Index';
import PageNotFound from '@/components/Home/Compliances/PageNotFound';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: Guard.auth,
      children: [
        {
          path: 'requests',
          name: 'requests',
          component: Requests,
        },
        {
          path: 'compliances',
          name: 'compliances',
          component: Compliances,
          children: [
            {
              path: ':items',
              name: 'items',
              component: Items
            },
            {
              path: '/:items/:pathMatch(.*)*',
              component: PageNotFound
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: Guard.guest
    },
    {
      path: '/print-interpretation',
      name: 'Print Interpretation',
      component: PrintInterpretation,
      beforeEnter: Guard.auth
    },
    {
      path: '/print-translation',
      name: 'Print Translation',
      component: PrintTranslation,
      beforeEnter: Guard.auth
    },
    {
      path: '/print-telephonic',
      name: 'Print Telephonic',
      component: PrintTelephonic,
      beforeEnter: Guard.auth
    },
    {
      path: '/print-digital',
      name: 'Print Digital',
      component: PrintDigitalSignature,
      beforeEnter: Guard.auth
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      beforeEnter: Guard.guest
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      beforeEnter: Guard.guest
    },
    {
      path: '/availability',
      name: 'CaptureAvailability',
      component: CaptureAvailability,
      beforeEnter: Guard.guest
    },
    {
      path: '/reminders',
      name: 'CaptureReminders',
      component: CaptureReminders,
      beforeEnter: Guard.guest
    },
    {
      path: '/po-confirm',
      name: 'CapturePoConfirm',
      component: CapturePoConfirm,
      beforeEnter: Guard.guest
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      beforeEnter: Guard.guest
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ,
      beforeEnter: Guard.guest
    },
    {
      path: '/capture-digital-vos',
      name: 'CaptureDigitalVOS',
      component: CaptureDigitalVOS,
      beforeEnter: Guard.guest
    },
    {
      path: '/signature',
      name: 'CaptureSignature',
      component: CaptureSignature,
      beforeEnter: Guard.guest
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})